<div class="weekly-schedule">
  <mat-progress-bar
    *ngIf="isAllServiceSchedulesLoading$ | async"
    mode="indeterminate"
    [color]="'accent'"
    [style.height]="'2px'"></mat-progress-bar>
  <div class="weekly-schedule-header row">
    <div class="col-6 col-md header-title">Weekly Pickup Schedule</div>
    <div
      class="col-6 col-md-auto button-container text-right"
      *appFeature="'AllSites'">
      <button class="rts-inverse-button" (click)="onShowAllSites()">
        Show All Sites
      </button>
    </div>
    <div class="col-6 col-md-auto date-range-container">
      <span class="date-range-text">{{ monthYearRangeString }}</span>
    </div>
    <div class="col-6 col-md-auto text-right navigation-arrows-container">
      <img
        src="assets/images/arrow_back.svg"
        alt="Previous Week"
        href="#weekly-schedule-carousel"
        role="button"
        data-slide="prev"
        (click)="previousWeek()" />
      <img
        src="assets/images/arrow_back.svg"
        alt="Next Week"
        href="#weekly-schedule-carousel"
        role="button"
        data-slide="next"
        (click)="nextWeek()" />
    </div>
  </div>
  <div
    class="carousel slide"
    id="weekly-schedule-carousel"
    *ngIf="calendarDays.length">
    <div class="carousel-inner">
      <div
        class="carousel-item"
        *ngFor="let weekDays of calendarDays; let i = index"
        [ngClass]="{ active: i === displayWeek }">
        <div
          *ngFor="let weekDay of weekDays"
          class="text-center schedule-column"
          [ngClass]="{
            active:
              todayDate.toLocaleDateString() ===
              weekDay.date.toLocaleDateString(),
            inactive: todayDate > weekDay.date
          }">
          <div class="weekly-schedule-column-header">
            <div class="header-day-text">
              {{ weekdayLookUpArray[weekDay.date.getDay()] }}
            </div>
            <div>
              <div class="header-day-number">
                <div>{{ weekDay.date.getDate() }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="schedule-column-content">
          <div
            class="text-center schedule-column"
            *ngFor="let weekDay of weekDays"
            [ngClass]="{
              active:
                todayDate.toLocaleDateString() ===
                weekDay.date.toLocaleDateString(),
              inactive: todayDate > weekDay.date
            }">
            <cdk-virtual-scroll-viewport
              itemSize="73"
              class="weekly-schedule-column-content">
              <app-weekly-service-calendar-block
                *cdkVirtualFor="let schedule of weekDay.schedules"
                [scheduleInfo]="schedule"
                [colorScheme]="
                  todayDate < weekDay.date
                    ? 'blue'
                    : todayDate > weekDay.date
                      ? 'grey'
                      : 'green'
                ">
              </app-weekly-service-calendar-block>
            </cdk-virtual-scroll-viewport>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
